<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="grid grid-cols-12">
                <div class="col-span-12 mb-4 lg:col-span-6 lg:pr-4 lg:mb-0">
                    <vx-badge color="violet" size="sm" class="px-2!">
                        Optional
                        <font-awesome-icon widthAuto :icon="faPencilSlash"></font-awesome-icon>
                    </vx-badge>
                    <h3 class="mt-2 text-xl text-slate-700 font-extrabold">Starter Template</h3>
                    <p class="text-sm">
                        Download a template to get going. <br />
                        Available columns:
                    </p>
                    <ul class="text-sm font-mono list-disc pl-4">
                        <li>group_id <small class="font-bold">required</small></li>
                        <li>group_name</li>
                        <li>group_time_zone</li>
                        <li>group_address</li>
                        <li>group_address_line_2</li>
                        <li>group_city</li>
                        <li>group_state</li>
                        <li>group_zip</li>
                        <li>group_country</li>
                    </ul>
                </div>
                <div class="col-span-12 lg:col-span-6">
                    <csv-template :downloadHref="csvUrl">
                        <template v-slot:head>
                            <tr>
                                <th>group_id</th>
                                <th>group_name</th>
                                <th>group_time_zone</th>
                            </tr>
                        </template>

                        <tr>
                            <td>store-001</td>
                            <td>Downtown Store</td>
                            <td>America/New_York</td>
                        </tr>
                        <tr>
                            <td>store-002</td>
                            <td>Mall Location</td>
                            <td></td>
                        </tr>
                    </csv-template>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import { VxExpandableCard, VxBadge } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import csvUrl from '@csv/groups_csv_upload_template.csv';
import CsvTemplate from '~/components/general/CsvTemplate.vue';
</script>
